import { styled } from '@compiled/react';
import React, { forwardRef, useContext } from 'react';
import { defineMessages } from 'react-intl-next';

import { SPAViewContext } from '@confluence/spa-view-context';
import { WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID } from '@confluence/whiteboard-utils';

import { ConfluenceEdition } from '../Upgrade/__types__/waitForEditionChangeQuery';
import { MiniSectionMessage } from '../UpsellLooknFeel/MiniSectionMessage';

const i18n = defineMessages({
	whiteboardPaywallReadOnlyBannerViewOnlyTextAdmin: {
		id: 'change-edition.whiteboard-upsell.paywall-read-only-banner.text-admin',
		defaultMessage:
			'<b>This whiteboard is view-only.</b> Your current plan only allows three active whiteboards. Upgrade to Premium for unlimited whiteboards.',
		description:
			'Text informing the user the whiteboard is view only and to upgrade and change plans for unlimited whiteboards.',
	},
	whiteboardPaywallReadOnlyBannerViewOnlyTextNonAdmin: {
		id: 'change-edition.whiteboard-upsell.paywall-read-only-banner.text-non-admin',
		defaultMessage:
			'<b>This whiteboard is view-only.</b> Your current plan only allows three active whiteboards. Ask your admin to upgrade to Premium for unlimited whiteboards.',
		description:
			'Text informing the user the whiteboard is view only and to ask their admin to change plans for unlimited whiteboards.',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WhiteboardPaywallReadOnlyBannerWrapper = styled.div({
	minHeight: '48px',
});

interface WhiteboardPaywallReadOnlyBannerProps {
	analyticsSource: string;
}

export const WhiteboardPaywallReadOnlyBanner = forwardRef<
	HTMLDivElement,
	WhiteboardPaywallReadOnlyBannerProps
>(({ analyticsSource }, ref) => {
	const { isSiteAdmin } = useContext(SPAViewContext);
	const bannerMessage = isSiteAdmin
		? i18n.whiteboardPaywallReadOnlyBannerViewOnlyTextAdmin
		: i18n.whiteboardPaywallReadOnlyBannerViewOnlyTextNonAdmin;

	return (
		<WhiteboardPaywallReadOnlyBannerWrapper ref={ref}>
			<MiniSectionMessage
				messageContent={{
					...bannerMessage,
					values: {
						b: (chunks) => <b>{chunks}</b>,
					},
				}}
				source={analyticsSource}
				targetEdition={ConfluenceEdition.PREMIUM}
				upgradeEditionActionSubjectId={WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID}
			/>
		</WhiteboardPaywallReadOnlyBannerWrapper>
	);
});
